import {HttpClient, RestResponse} from "./resources";
import {Injectable} from "@angular/core";
import {Http, RequestOptions} from "@angular/http";

@Injectable()
export class ResourcesClient implements HttpClient {

  constructor(private http: Http) {
  }

  request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any> {
    let requestOptions = new RequestOptions();
    if (requestConfig.queryParams) {
      requestOptions.params = requestConfig.queryParams;
    }
    switch (requestConfig.method) {
      case 'GET': {
        if (requestConfig.queryParams) {
          return this.http.get(requestConfig.url, requestOptions).map(reponse => reponse.json()).share();
        } else {
          return this.http.get(requestConfig.url, requestConfig.data).map(reponse => reponse.json()).share();
        }
      }
      case 'POST': {
        return this.http.post(requestConfig.url, requestConfig.data, requestOptions).map(reponse => reponse.json()).share();
      }
      case 'DELETE': {
        if (requestConfig.queryParams) {
          return this.http.delete(requestConfig.url, requestOptions).map(reponse => reponse.json()).share();
        } else {
          return this.http.delete(requestConfig.url, requestConfig.data).map(reponse => reponse.json()).share();
        }
      }
      case 'PUT': {
        return this.http.put(requestConfig.url, requestConfig.data, requestOptions).map(reponse => reponse.json()).share();
      }
      default:
        throw "Invalide argument";
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/resources/resources.client.ts